import { useCallback, useState } from 'react';

const usePopover = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [position, setPosition] = useState<{ top: number; left: number } | null>(null);

  const handleOpen = useCallback((event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    const rect = event.currentTarget.getBoundingClientRect();
    setPosition({
      top: rect.bottom,
      left: rect.right,
    });
    setAnchorEl(event.currentTarget);
  }, []);

  const handleClose = useCallback(() => {
    setAnchorEl(null);
    setPosition(null);
  }, []);

  return {
    anchorEl,
    position,
    isOpen: Boolean(anchorEl),
    handleOpen,
    handleClose,
  };
};

export default usePopover;
